import CakeChartComponent from './CakeChart/CakeChart'
import ClientCardComponent from './ClientCard/ClientCard'
import ContentComponent from './Content/Content'
import ContentTopBarComponent from './ContentTopBar/ContentTopBar'
import FiltersComponent from './Filters/Filters'
import SidebarComponent from './Sidebar/Sidebar'
import TableHeadersComponent from './TableHeaders/TableHeaders'
import ModalRiskComponent from './ModalRisk/ModalRisk'

export const CakeChart = CakeChartComponent
export const ClientCard = ClientCardComponent
export const Content = ContentComponent
export const ContentTopBar = ContentTopBarComponent
export const Filters = FiltersComponent
export const Sidebar = SidebarComponent
export const TableHeaders = TableHeadersComponent
export const ModalRisk = ModalRiskComponent
